import * as types from './types';
import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { SITESETUP_CLEAR_FETCHED } from '../types';

const INITIAL_STATE = {
  data: {},
  error: null,
  fetching: false,
  fetched: false,
  storageLocations: [],
  handlingFee: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SITESETUP_CLEAR_FETCHED:
      return {
        ...state,
        fetched: false,
      };

    case types.SITESETUP_SITE_DETAILS_FETCHING:
      return {
        ...state,
        fetched: false,
        fetching: action.payload,
      };

    case types.SITESETUP_GET_SITE_DETAILS:
      const { calendar, data, warehousesAndKitchens } = action.payload;

      data.Data.MBEDate = calendar[Fields.MbeEnabled]
        ? defaultDateFormat(calendar[Fields.MealExpirationDT])
        : 'Not Enabled';

      const dataValue = Object.assign({}, data.Data, {
        WarehousesAndKitchens: warehousesAndKitchens,
      });
      return {
        ...state,
        data: dataValue,
        fetched: true,
      };

    case types.SITESETUP_GET_SITE_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.SITESETUP_CLEAR_SITE_DETAILS:
    case types.SITESETUP_UPDATE_SITE_DETAILS:
      return {
        ...state,
        data: action.payload,
      };
    case types.GET_STORAGE_LOCATION:
      return {
        ...state,
        storageLocations: action.payload,
      };
    case types.GET_HANDLING_FEE:
      return {
        ...state,
        handlingFee: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/siteDetails/reducer.js